import { render, staticRenderFns } from "./ModelFieldControl.vue?vue&type=template&id=84cbc20c"
import script from "./ModelFieldControl.vue?vue&type=script&lang=ts"
export * from "./ModelFieldControl.vue?vue&type=script&lang=ts"
import style0 from "./ModelFieldControl.vue?vue&type=style&index=0&id=84cbc20c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports